<script setup>
import { useSearchStore } from '@/stores/SearchStore'
import { useBatchStore } from '@/stores/BatchStore'
import { CARD_TYPES } from '@/constants'
import moment from 'moment'

const props = defineProps({
  active: { type: Boolean, default: false },
  item: { type: Object, required: true },
  selectedCard: { type: Object, default: null }
})

const searchStore = useSearchStore()
const batchStore = useBatchStore()

</script>
<template>
<li
  class="flex items-center justify-between p-3 transition duration-300 hover:bg-blue-50 cursor-pointer group"
  :class="{ 'bg-blue-50': props.active, 'bg-gray-200 pointer-events-none cursor-default': props.selectedCard && ((!batchStore.selectedBatch?.lock_id && props.item?.lock_id) || (!batchStore.selectedBatch?.locked_sets?.length && props.item?.locked_sets?.length)) }"
>
  <div class="flex items-center gap-x-3 w-full">
    <div
      class="w-10 pt-2 px-1 relative flex-shrink-0 group-pics-style"
    >
      <img src="@/assets/images/place-cards/1.png" />
      <img src="@/assets/images/place-cards/2.png" />
      <img src="@/assets/images/place-cards/3.png" />
    </div>
    <div class="flex-auto">
      <h3 class="font-medium">{{ props.item.name }}</h3>
      <p class="text-gray-500">{{CARD_TYPES[props.item.type]}} Card . Imported {{ moment(props.item.created_at).format('MMMM DD YYYY . h:mm:ss A') }}</p>
    </div>
    <div 
      v-if="props.selectedCard && ((!batchStore.selectedBatch?.lock_id && props.item?.lock_id) || (!batchStore.selectedBatch?.locked_sets?.length && props.item?.locked_sets?.length))"
      class="py-1 px-2 bg-blue-100 rounded-xl"
    >
      <span class='text-gray-500 text-[10px]'>Lock Set Batch</span>
    </div>
    <button
      v-if="searchStore.cdp_search.locationOfSearchCall === 'add-button'"
      class="
        alternative-button text-xs py-1 text-tint-1 focus:ring-tint-1/20 transition duration-300 opacity-0
        group-hover:opacity-100
      "
      :class="{'!opacity-100': props.active}"
    >
      Add Cards
    </button>
    <button
      v-else-if="props.selectedCard && !props.item?.lock_id && !props.item?.locked_sets?.length"
      class="
        alternative-button text-xs py-1 text-tint-1 focus:ring-tint-1/20 transition duration-300 opacity-0
        group-hover:opacity-100
      "
      :class="{'!opacity-100': props.active}"
    >
      Add Selected Card
    </button>
  </div>
</li>
</template>